import { apiUrls } from '../../../../common';
import { apiPut, apiPost, getLoggedInUserID } from '../../../../utils';

const { USER: USER_MODULE } = apiUrls;

export const changePasswordHelper = (requestData) => apiPost(USER_MODULE.CHANGE_PASSWORD, requestData);

export const updateProfileHelper = (requestData, userID = getLoggedInUserID()) =>
  apiPut(`${USER_MODULE.ME(userID)}`, requestData);
